import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthSnapshotService } from 'src/app/store/auth/auth-snapshot.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  /**
   * Reads the session from the store rather than localStorage.
   *
   * AuthSnapshotService caches plain fields off a single subscription, so this
   * stays synchronous — which it must be, since headers are built inline. The
   * store is hydrated during root-injector construction, so the token is already
   * there by the time the first request goes out.
   */
  constructor(private auth: AuthSnapshotService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let header = new HttpHeaders();
    header = header.set('Accept-Language', 'en');

    // The token is stored decoded, so it goes straight onto the header - the
    // JSON.stringify quotes exist only in localStorage.
    if (this.auth.token) {
      header = header.append('Authorization', 'Bearer ' + this.auth.token);
    }

    if (this.auth.collabOrgId) {
      header = header.append('X-Collaboration-Organisation', this.auth.collabOrgId);
    }

    // Appended rather than set, so a signed-in user ships `Accept-Language: en, <code>`
    // exactly as before. Collapsing it to a single value would be a silent change
    // for a backend that reads this as a q-list.
    if (this.auth.user) {
      header = header.append('Accept-Language', this.auth.acceptLanguage);
    }

    request = request.clone({
      headers: header,
      withCredentials: true,
    });

    // If environment api url contains localhost
    if (environment.apiUrl.includes('localhost')) {
      console.log("AuthInterceptor: ", request);
    }

    return next.handle(request);
  };
}
